
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { globalStore, uiStore } from "@/store/store";
import { CSSSelector } from "@/types/selectors";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";

@Component({
  components: { Dropdown, NiceButton, TextInput }
})
export default class AddClass extends Vue {
  @Prop()
  existingClasses!: string[];

  newClassName: string | null = null;
  autocompleteListIndex = -1;

  get allClasses() {
    return globalStore.cssSelectors.filter(s => s.type === "class");
  }

  autofocus = false;
  beforeMount() {
    if (uiStore.keyboardTriggeredActions.openClassesDropdown === "pending") {
      this.autofocus = true;
      uiStore.setKeyboardTriggeredActions({
        ...uiStore.keyboardTriggeredActions,
        openClassesDropdown: null
      });
    }
  }

  get newClassNameAlreadyExists() {
    return !!this.allClasses.find(
      c => c.name === this.newClassName || c.name === `.${this.newClassName}`
    );
  }

  get items() {
    const bag = [];

    if (!this.newClassNameAlreadyExists && this.newClassName) {
      const newClass = this.newClassName.replace(".", ""); // Strip duplicate dot in the UI
      bag.push({
        text: `Create <em>.${newClass}</em>`,
        value: this.newClassName
      });
    }

    if (this.autocompleteClassNames.length > 0) {
      bag.push({
        header: "Existing Classes"
      });

      bag.push(...this.autocompleteClassNames);
    }

    return bag;
  }

  addClass(className: string | null) {
    this.newClassName = null;
    if (!className) return;
    this.$emit("input", className);
    this.autocompleteListIndex = -1;
  }

  get autocompleteClassNames() {
    const includesSearchString = (cssClass: CSSSelector) => {
      if (!this.newClassName) return true;
      return cssClass.name.includes(this.newClassName);
    };

    const removeClassesAlreadyPresent = (cssClass: CSSSelector) =>
      !this.existingClasses.includes(cssClass.name);

    return this.allClasses
      .filter(includesSearchString)
      .filter(removeClassesAlreadyPresent)
      .map(cssClass => {
        return {
          text: cssClass.name,
          value: cssClass.name
        };
      });
  }

  onEnter(className: string | null) {
    if (this.autocompleteListIndex !== -1) return;
    this.addClass(className);
  }

  onListIndexUpdate(index: number) {
    this.autocompleteListIndex = index;
  }
}
